define(['jquery', 'Cloud/Application/api', 'require'], function($, api, require) {
	return function(app, _) {
		const { captureMessage } = require('@sentry/browser');
		const IS_MY_TEAM = app.getParam("IS_MY_TEAM");
		const { vkTeamBridge } = require('reactApp/modules/vkTeam/vkTeam.module');

		Object.assign(_, {
			openTab(url, name) {
				if (!IS_MY_TEAM) {
					const tab = window.open(url, name || '');

					if ( tab ) {
						tab.focus();
					}

					return tab;
				}

				
				vkTeamBridge
				.send('OpenLink', { url })
				.catch((error) => {
					console.error(error);
				});
			}

			, openTabViaLink(url, downloadName) {
				// cloud-1674 Mobile Safari doesn't respect 'Content-Disposition: attachment' header
				// cloud-1722 Android stock browser doesn't start download
				// http://www.digiblog.de/2011/04/android-and-the-download-file-headers/

				let $el = $('<a />', {
					href: url
					, target: '_blank'
					, css: {
						position: "absolute"
						, visibility: "hidden"
					}
				})
					.appendTo('body')
				;

				if ( downloadName ) {// CLOUDWEB-4348
					$el.attr('download', downloadName);
				}

				let domElement = $el[0];
				let event = null;

				try {
					event = new (window.MouseEvent || window.Event)("click", {cancelable: false, bubbles: false});
				}
				catch(error) {
					event = window.document.createEvent("Events");
					event.initEvent( "click", false, false );
				}

				domElement.dispatchEvent(event);// we do not consider the case when event was canceled/prevented (dispatchEvent return false)

				$el.remove();
				event = null;
				domElement = null;
				$el = null;
			}

			, openPopup(url, name) {
				const popup = window.open(url, name, 'toolbar=0,status=0,menubar=0,location=0,directories=0,width=626,height=436');

				if ( popup ) {
					popup.focus();

				} else {
					captureMessage('POPUP BLOCKED', {
						arguments: {
							url
						}
					});

					api.emit('api-fail', 200, 'popup-open');
				}

				return popup;
			}
		})
	}
});
